var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.501 3.2-8.465 8.465a.338.338 0 0 0-.088.155L.01 15.585a.335.335 0 0 0 .404.403l3.766-.938a.333.333 0 0 0 .154-.088L12.8 6.498 9.501 3.2ZM15.526 1.379 14.611.46c-.612-.614-1.678-.613-2.29 0l-1.12 1.125L14.404 4.8l1.121-1.125c.306-.306.474-.714.474-1.148 0-.434-.168-.842-.474-1.149Z",
    fill: "#000"
  })));
};
export default SvgPencil;